<template>

    <div class="page-content">
        <div class="points-allocation-page-container-wrapper defaultShadow" v-if="page.description">
            <div class="points-allocation-page-container contentBackground">
                <div class="points-allocation-page-item textColor">
                    <slot name="description">
                    </slot>
                </div>
            </div>
        </div>

        <div class="points-allocation-page-container-wrapper defaultShadow">
            <div class="points-allocation-page-container points-remaining themePrimaryColor contentBackground">
                <div class="points-allocation-page-item textColor">
                    <div class="points-allocation-points-remaining">{{ lang.get('event_strings.points_allocation_page.points_remaining') }}</div>
                    <div class="score-font">{{ pointsRemaing() }}</div>
                    <div class="points-allocation-points-used">{{ lang.get('event_strings.points_allocation_page.points_used').replace("{AMOUNT}",pointsUsed()) }}</div>
                </div>
            </div>
        </div>

        <points-allocation-group
            v-for="group in groups"
            :key='group.group_id'
            v-bind:group="group"
            v-bind:gamePointTypes="gamePointsRemaing"
            v-bind:pointsUsed="gamePointsUsed"
            @group-donate="donate"
        >
        </points-allocation-group>
    </div>

</template>

<script>

export default {
    props: [
        'eventId',
        'page',
        'description',
        'pointSlugs',
        'eventAttendeePointsUsed',
        'baseUrl',
        'isWeb',
        'apiAuthToken'
    ],

    data() {
        return {
            search: '',
            groups: [],
            gamePointsRemaing: this.pointSlugs,
            gamePointsUsed: this.eventAttendeePointsUsed
        }
    },

    computed: {
    },

    methods: {
        getFormattedURL(relativePath) {
        var url = relativePath

        if(this.isWeb != 'true') {
            url = `/events/${this.eventId}`+url
        }

        if ((typeof this.baseUrl === 'string' || this.baseUrl instanceof String) && this.baseUrl != '') {
            url = this.baseUrl+url
        }

        return url
        },

        pointsRemaing () {
            return this.totalPoints()
        },
        pointsUsed () {
            var total = 0
            Object.values(this.gamePointsUsed).forEach(points => {
                points.forEach(point => {
                    total += point.points_result
                });
            });

            return total
        },
        totalPoints () {
            var total = 0
            Object.values(this.gamePointsRemaing).forEach(points => {
                points.forEach(point => {
                    total += point.points_result
                });
            });

            return total
        },

        groupItems: function () {
            let url = this.getFormattedURL(`/points-allocation-page/${this.page.id}/search`);
            axios.get(url, {
                params: {
                    api_auth_token: this.apiAuthToken, 
                    query: this.search ?? '',
                }
            })
            .then(data => {
                this.groups = data.data.data
            });

            return null
        },

        donate (groupId, eventAttendeePointId, gamePointValueId) {
            var self = this
            var url = this.getFormattedURL(`/points-allocation-page/${this.page.id}/donate`);

			axios({
                url: url,
                data: {
                    api_auth_token: this.apiAuthToken,
                    event_attendee_point_id: eventAttendeePointId,
                    game_point_allocation_group_id: groupId,
                    game_point_id: gamePointValueId
                },
                method: 'post',
                responseType: 'json'
            })
            .then((res) => {
                self.groupItems()
                self.gamePointsRemaing = res.data.eventAttendeePointsRemaining
                self.gamePointsUsed = res.data.eventAttendeePointsUsed
            })
            .catch((err) => { 
                console.log(err)
            }).finally(() => {
            })  
        }
    },

    mounted () {
        this.groupItems()

        document.getElementById('groups-search-input').addEventListener('input',  function(e){
            this.search = e.target.value ?? ''
            this.groupItems()
        }.bind(this))
    }
};

</script>